module.exports = __webpack_public_path__ + "img/loginBg.a708728d.png";